module.exports = __webpack_public_path__ + "img/client-4.d77f8459.webp";